//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BCard, BCardText } from "bootstrap-vue";
import { Icon } from "@iconify/vue2";
import { getCourseDurationText } from "~/utils/course";
import { getDiscountPercent, getDiscountImageSrc, areDiscountsEnabled, hasDiscount } from "~/utils/discount";

export default {
  name: "CourseCard",
  components: { BCard, BCardText, Icon },
  props: {
    image: String,
    imgAlt: String,
    language: String,
    duration: Object,
    name: String,
    slug: String,
    shortName: String,
    shortDescription: String,
    category: [String, Array],
    url: [String, Object],
    level: String,
  },
  computed: {
    discountPercent() {
      return getDiscountPercent(this.shortName);
    },
    discountImageSrc() {
      return getDiscountImageSrc(this.shortName);
    },
    shouldShowDiscount() {
      return areDiscountsEnabled() && hasDiscount(this.shortName);
    },
    displayCategory() {
      return Array.isArray(this.category) ? this.category[0] : this.category;
    }
  },
  methods: {
    getCourseDurationText,
  },
};
